import { DurationUnit } from 'luxon';

enum DurationPart {
    Years = 'Years',
    Months = 'Months',
    Weeks = 'Weeks',
    Days = 'Days',
    Hours = 'Hours',
    Minutes = 'Minutes',
    Seconds = 'Seconds',
}

export const durationUnitByDurationPart: Record<DurationPart, DurationUnit> = {
    [DurationPart.Years]: 'years',
    [DurationPart.Months]: 'months',
    [DurationPart.Weeks]: 'weeks',
    [DurationPart.Days]: 'days',
    [DurationPart.Hours]: 'hours',
    [DurationPart.Minutes]: 'minutes',
    [DurationPart.Seconds]: 'seconds',
};

export default DurationPart;
